module.exports = __webpack_public_path__ + "static/media/Ulm.33983f11.png";